import { Component, inject, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthenticationService } from '@core/auth/authentication.service';
import { LabelComponent } from '@shared/components/form/label/label.component';
import { ButtonComponent } from '@shared/components/ui/button/button.component';
import { IconButton } from '@shared/components/ui/icon-button/icon-button';
import { InputFieldComponent, SelectFieldComponent, SelectOption } from '@shared/components/ui/list-components';
import { CombosService } from '@shared/services/combos.service';
import { DialogService } from '@shared/services/dialog.service';
import { ErrorService } from '@shared/services/error.service';
import { Zona } from '@shared/services/interfaces/combos.interface';
import { CrearZonaModal } from '../../../ubicacion/zonas/crear-zona-modal/crear-zona-modal';
import { OBJETIVOS_ESTABLECIMIENTO } from '../establecimiento-modal/establecimiento-modal';
import {
  errorFilaEstablecimiento,
  FilaEstablecimiento,
  filaEstablecimientoConDatos,
  filaEstablecimientoVacia,
} from '../establecimientos-grilla/establecimientos-grilla';

/**
 * Establecimientos del alta de cliente como bloques de campos, uno debajo del otro,
 * con "Agregar otro". Usa las mismas filas que la grilla, así el alta arma el envío
 * igual. El componente padre es dueño del arreglo.
 */
@Component({
  selector: 'app-establecimientos-campos',
  imports: [FormsModule, LabelComponent, InputFieldComponent, SelectFieldComponent, IconButton, ButtonComponent],
  templateUrl: './establecimientos-campos.html',
})
export class EstablecimientosCampos implements OnInit {
  @Input({ required: true }) filas: FilaEstablecimiento[] = [];
  /** Muestra lo que le falta a cada bloque (después de intentar guardar). */
  @Input() mostrarErrores = false;
  @Input() deshabilitada = false;

  zonas: Zona[] = [];
  objetivoOptions = OBJETIVOS_ESTABLECIMIENTO;

  private combosService = inject(CombosService);
  private errorService = inject(ErrorService);
  private dialogService = inject(DialogService);
  private authService = inject(AuthenticationService);

  get zonasOptions(): SelectOption[] {
    return this.zonas.map(z => ({ value: '' + z.id, label: z.nombre }));
  }

  get puedeCrearZona(): boolean {
    return this.authService.canView('zonas') && this.authService.canCreate('zonas');
  }

  ngOnInit(): void {
    if (!this.filas.length) this.filas.push(filaEstablecimientoVacia());
    this.cargarZonas();
  }

  agregar(): void {
    this.filas.push(filaEstablecimientoVacia());
  }

  quitar(fila: FilaEstablecimiento): void {
    this.filas.splice(this.filas.indexOf(fila), 1);
    if (!this.filas.length) this.filas.push(filaEstablecimientoVacia());
  }

  /** `type=number` entrega number o null; la fila guarda texto como la grilla. */
  onKm(fila: FilaEstablecimiento, valor: string | number | null): void {
    fila.km = valor === null || valor === undefined ? '' : '' + valor;
  }

  mensaje(fila: FilaEstablecimiento): string | null {
    return this.mostrarErrores && filaEstablecimientoConDatos(fila) ? errorFilaEstablecimiento(fila) : null;
  }

  crearZona(fila: FilaEstablecimiento): void {
    this.dialogService
      .openForm(CrearZonaModal, { size: 'md' })
      .afterClosed()
      .subscribe((zona) => {
        if (!zona) return;
        this.cargarZonas(() => fila.ubi_zona_id = String(zona.id));
      });
  }

  private cargarZonas(despues?: () => void): void {
    this.combosService.getAllZonasCombo().subscribe({
      next: (response) => {
        this.zonas = response.data;
        despues?.();
      },
      error: (error) => this.errorService.handleError(error),
    });
  }
}
